import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'

const getUsers = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'users'), params)
}

const getAllUsers = (application, params = {}) => {
  return clientHTTP.getAll(getLinkHref(application, 'users'), params)
}

const getAuthenticatedUser = (application) => {
  return clientHTTP.get(getLinkHref(application, 'authenticatedUser'))
}

const getAuthenticatedUserCustomer = (user) => {
  return clientHTTP.get(getLinkHref(user, 'customer'))
}

const createUser = (application, params = {}) => {
  const url = getLinkHref(application, 'users') + '?' + clientHTTP.encodeParams({ url: window.location.origin + '/#/validateUser' })
  return clientHTTP.post(url, params)
}

const getUser = (application, id) => {
  return clientHTTP.get(getLinkHref(application, 'users') + `/${id}`)
}

const patchUser = (user, params) => {
  return clientHTTP.patch(
    getLinkHref(user, 'self') + '?' + clientHTTP.encodeParams({ url: window.location.origin + '/#/validateUser' }),
    params
  )
}

const sendValidationEmail = (user) => {
  return clientHTTP.post(getLinkHref(user, 'validationEmail') + '?' + clientHTTP.encodeParams({ url: window.location.origin + '/#/validateUser' }))
}

const deleteUser = (user) => {
  return clientHTTP.delete(getLinkHref(user, 'self'))
}

const validateUser = (application, token) => {
  return clientHTTP.post(
    getLinkHref(application, 'validateUser'),
    {},
    { 'Authorization': 'Bearer ' + token }
  )
}

const getRoles = (application) => {
  return clientHTTP.getAll(getLinkHref(application, 'roles'))
}

export default {
  getUsers,
  getAllUsers,
  getAuthenticatedUser,
  getAuthenticatedUserCustomer,
  createUser,
  getUser,
  patchUser,
  sendValidationEmail,
  deleteUser,
  validateUser,
  getRoles
}
